import { render, staticRenderFns } from "./UploadImagemEmailAniversarioProprietarioDialog.vue?vue&type=template&id=6ea73222&"
import script from "./UploadImagemEmailAniversarioProprietarioDialog.vue?vue&type=script&lang=js&"
export * from "./UploadImagemEmailAniversarioProprietarioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports